import type { ReactNode } from 'react';
import { cn } from '../lib/cn.js';

export interface KbdProps {
  children: ReactNode;
  className?: string;
}

/** Keyboard hint: mono 10px, bordered 2px radius. Use `⌘K`, `↵`, `Esc`. */
export function Kbd({ children, className }: KbdProps) {
  return (
    <kbd
      className={cn(
        'inline-flex h-4 min-w-4 items-center justify-center rounded-sm border border-line bg-bg px-1 font-mono text-2xs text-mute',
        className,
      )}
    >
      {children}
    </kbd>
  );
}
